/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsSerialNumberHistory,
    MelcoModelsSerialNumberHistoryFromJSON,
    MelcoModelsSerialNumberHistoryFromJSONTyped,
    MelcoModelsSerialNumberHistoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsSerialNumberHistory
 */
export interface MelcoModelsGenericList1MelcoModelsSerialNumberHistory {
    /**
     * 
     * @type {Array<MelcoModelsSerialNumberHistory>}
     * @memberof MelcoModelsGenericList1MelcoModelsSerialNumberHistory
     */
    list: Array<MelcoModelsSerialNumberHistory>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsSerialNumberHistory
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsSerialNumberHistory
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSON(json: any): MelcoModelsGenericList1MelcoModelsSerialNumberHistory {
    return MelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsSerialNumberHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsSerialNumberHistoryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsSerialNumberHistoryToJSON(value?: MelcoModelsGenericList1MelcoModelsSerialNumberHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsSerialNumberHistoryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


